import { render, staticRenderFns } from "./TotalUangSakuMagangChart.vue?vue&type=template&id=2621e366&scoped=true"
import script from "./TotalUangSakuMagangChart.vue?vue&type=script&lang=js"
export * from "./TotalUangSakuMagangChart.vue?vue&type=script&lang=js"
import style0 from "./TotalUangSakuMagangChart.vue?vue&type=style&index=0&id=2621e366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2621e366",
  null
  
)

export default component.exports